import $http from "../../axios-instance";

/**
 * Cargar la URL larga mediante la URL corta.
 *
 * @param Object commit
 * @param String code: identificador de la URL corta.
 * @author Fernando Claros
 */
export async function directToOriginalURL({ commit }, code) {
    commit("dashboard/load", true, { root: true });
    commit("setLoading", true);

    await $http
        .get(`urls-shorter/${code}`)
        .then(({ data: response }) => {
            
            commit("setUrlShorter", response.data)

            if (response.data && typeof response.data === 'object' && 'urlShorter' in response.data && 
                typeof response.data.urlShorter === 'object' && 'original_url' in response.data.urlShorter
            ) {
                window.location.assign(response.data.urlShorter.original_url)
            }

        })
        .catch(() => {
            this.$vue.$alertConfirmation({
                icon: "error",
                title: "Proceso fallido", 
                text: "Error al intentar procesar la URL.", 
                showCancelButton: true, 
                titleBtnCancel: "Ok, salir.",
                onDismiss: onDismissProcess               
            });
        })
        .finally(() => {
            commit("dashboard/load", false, { root: true });
            commit("setLoading", false);
        });
}

/**
 * Acción que se ejecuta cuando finaliza el proceso.
 * 
 * (Al cerrar el modal).
 */
function onDismissProcess() {
    window.location.assign(process.env.VUE_APP_ENDPOINT_WEB_SOLUQUIM)
}